import { useEffect, useState } from 'react';
import { Card, CardHeader, CardContent, Button, Container } from '@material-ui/core';
import useVrackApi from '../hooks/useVrackApi';
import Page from '../components/Page';
import VMTemplatesTable from '../components/team/VMTemplatesTable';
import NewTemplateModal from '../components/team/NewTemplateModal';

export default function VMTemplates() {
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const openCreateModal = () => setIsCreateOpen(true);
  const closeCreateModal = () => setIsCreateOpen(false);

  const [vmTemplateList, setVmTemplateList] = useState([]);
  const { fetchData: vrackApiVMTemplateList } = useVrackApi('get', '/racks/vm');
  const getVMTemplateList = async () => {
    await vrackApiVMTemplateList('get', '/racks/vm')
      .then((response) => {
        console.debug('VM Templates were successfully retrieved from the API');
        setVmTemplateList(response);
      })
      .catch((error) => {
        console.debug(error);
      });
  };

  useEffect(() => {
    getVMTemplateList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page title="Teams | VM Templates | Virtual Racks">
      <Container maxWidth={false}>
        <Card>
          <CardHeader
            title="VM Templates"
            subheader="View and manage team-created VM templates"
            action={
              <Button
                data-testid="create-template-btn"
                color="primary"
                variant="contained"
                onClick={openCreateModal}
                sx={{ mt: 2 }}
              >
                Create Template
              </Button>
            }
          />
          <CardContent>
            <VMTemplatesTable vmTemplates={vmTemplateList} getVMTemplateList={getVMTemplateList} />
            <NewTemplateModal
              isOpen={isCreateOpen}
              closeHandler={closeCreateModal}
              vmTemplates={vmTemplateList}
              getVMTemplateList={getVMTemplateList}
            />
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}
